<div class="header">
    <div class="title">
        <img alt="PennDOT HBMS" src="{{imagePath}}/penndot_logo_glow.png">
        <h1>Highway Beautification Management System</h1>
    </div>
    <div class="right-side">
        <div class="search-container">
            <mc-search id="search" #search slot="top-right" max-results="50" add-selection-to-map="true"></mc-search>
        </div>
        <div class="button-container">
            <button class="btn aoi" (click)="openAoi()">
                <span class="icon-ui-maps before"></span>
                <span class="text">Change Area of Interest</span>
            </button>
            <button class="btn tools" (click)="toggleTools()">
                <span class="icon-ui-layer-list before"></span>
                <span class="text">Tools</span>
            </button>
            <button class="btn" (click)="openAbout()">
                <span class="icon-ui-description before"></span>
                <span class="text">About</span>
            </button>
        </div>
    </div>
</div>

<app-tools #tools></app-tools>

<mc-window #aoiWindow id="aoiWindow" modal="true" title="Select an Area of Interest" width="875">
    <div slot=content>
        <app-aoi #aoi id="aoi" [mapRef]="mcMap"></app-aoi>
    </div>
</mc-window>

<mc-window #aboutWindow id="aboutWindow" title="About HBMS" modal="true" width="700">
    <div slot="content">
        <div class="about-window">
            <h3>Highway Beautification Management System (HBMS)</h3>
            <h5>Version: {{ version }}</h5>
            <p> The Highway Beautification Management System (HBMS) is PennDOT's system to record outdoor advertising
                permits along controlled routes, which fall under the National System of Interstate Highways, the
                Federal-Aid Primary Highway System as these existed on June 1,1991, and/or the National Highway System
                (NHS), including the additional NHS controlled miles as amended by MAP 21. The HBMS Mapping Tool is a
                web based interactive map solution that is open, via the internet, to the public and PennDOT Department
                staff. The application shows permitted structures as interactive points that display information about
                the advertising device.
            </p>
            <div class="bottom">
                <button class="btn right" (click)="closeAbout()">Close</button>
            </div>
        </div>
    </div>
</mc-window>